import { basicInitialState } from '../_utils/basicInitialState';
import { TOwnersState } from './owners';

export const ownersInitialState: TOwnersState = {
  ...basicInitialState,
  owners: null
};
